"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emit = emit;
function emit(type, event) {
  return (_dispatch, _getState, context) => {
    context.emitter.emit(type, event);
  };
}